module.exports = __webpack_public_path__ + "static/media/austin.4e7cec61.webp";